import React from "react";
import Navmenu from "./Navmenu";
import { menuItems } from "@/constant/data";
import useSemiDark from "@/hooks/useSemiDark";

const Sidebar = () => {
  const [isSemiDark] = useSemiDark();

  return (
    <div className={isSemiDark ? "dark" : ""}>
      {/* Modern 2025 Compact Sidebar - Mobile Optimized */}
      <div className="sidebar-wrapper fixed top-0 left-0 h-screen w-[80px] bg-white/90 dark:bg-slate-900/90 backdrop-blur-xl border-r border-slate-200/50 dark:border-slate-700/50 z-[1000] transition-all duration-300 hover:shadow-2xl hover:shadow-blue-500/10 md:bg-white/80 md:dark:bg-slate-900/80">
        {/* Glassmorphism overlay */}
        <div className="absolute inset-0 bg-gradient-to-b from-white/20 to-transparent dark:from-slate-800/20 pointer-events-none rounded-r-xl"></div>
        
        {/* Logo Section */}
        <div className="flex items-center justify-center py-4 border-b border-slate-200/30 dark:border-slate-700/30 relative z-10">
          <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-blue-500 to-purple-600 flex items-center justify-center shadow-lg">
            <span className="text-white font-bold text-lg">S</span>
          </div>
        </div>

        {/* Navigation Menu */}
        <div className="flex flex-col h-[calc(100vh-80px)] py-4 relative z-10">
          <Navmenu menus={menuItems} />
        </div>

        {/* Modern accent line */}
        <div className="absolute right-0 top-20 bottom-20 w-[2px] bg-gradient-to-b from-transparent via-blue-500/30 to-transparent"></div>
      </div>
    </div>
  );
};

export default Sidebar;